<template>
  <v-footer color="primary">
    <v-container class="py-5">
      <div>
        <v-img
          style="margin-left: auto; margin-right: auto"
          :src="LogoCriptonomia"
          height="42"
          width="157"
        >
        </v-img>
      </div>
      <div class="d-flex flex-column flex-md-row justify-center text-center text-md-left">
        <v-btn
          v-for="(item, i) in $t('links')"
          :key="i"
          text
          class="mx-1"
          color="white"
          @click="$router.push(item.route)"
          style="text-transform: capitalize;"
        >
          {{ item.title }}
        </v-btn>
      </div>
      <v-divider class="my-3"></v-divider>
      <div class="d-flex justify-space-around">
        <div class="text-center caption" style="color: white;">
          {{ $t('footer.allRights') }}
        </div>
        <div class="text-center caption hidden-sm-and-down" style="color: white;">
          {{ $t('footer.follow') }}
        </div>
      </div>
      <div class="text-center text-md-right" style="color: white;">
        <v-btn
          fab
          small
          color="primary"
          class="ml-2"
          @click="openNewTab('https://twitter.com/criptonomiabr')"
        >
          <v-icon>mdi-twitter</v-icon>
        </v-btn>
        <v-btn
          fab
          small
          color="primary"
          class="ml-2"
          @click="openNewTab('https://www.linkedin.com/company/criptonomia/')"
        >
          <v-icon>mdi-linkedin</v-icon>
        </v-btn>
        <v-btn
          fab
          small
          color="primary"
          class="ml-2"
          @click="openNewTab('https://www.instagram.com/criptonomiabr/')"
        >
          <v-icon>mdi-instagram</v-icon>
        </v-btn>
      </div>
    </v-container>
  </v-footer>
</template>

<script>
import LogoCriptonomia from 'Assets/Landing/logo-criptonomia-branca.png';
export default {
  name: 'Rooter',
  data() {
    return {
      LogoCriptonomia,
      links: [
        {
          title: this.$t('principal.inicio'),
          route: '/',
        },
        {
          title: this.$t('principal.sobre'),
          route: '/about',
        },
        {
          title: this.$t('principal.produtos'),
          route: '/products',
        },
        {
          title: this.$t('principal.contato'),
          route: '/contact',
        },
      ],
    };
  },
  methods: {
    openNewTab(obj) {
      window.open(obj);
    },
  },
};
</script>
